import { TypeTable } from '../../../../../../../../shared/components/table/table.component.tsx';
import { Theme as theme } from '../../../../../../../../shared/styles/theme/theme.ts';

export const viewRows: TypeTable['viewRows'] = {
  action: ({ id }, api) => {
    if (typeof id === 'string' && id.startsWith('auto-generated-row-')) {
      const groupChildrenIds = api?.getRowGroupChildren({ groupId: id });
      const groupChildren = groupChildrenIds?.map((id) => api?.getRow(id));
      let hasError = Boolean(groupChildren?.some((el) => el?.error));
      if (hasError) {
        return 'error-group-row';
      }
    }

    return '';
  },
  styles: [
    {
      className: 'error-group-row',
      bgColor: theme.palette.red.light,
      bgColorSelected: theme.palette.red.light,
      rowStyles: {
        '&:[data-id^="auto-generated-row-"]': {
          backgroundColor: theme.palette.red.light,
        },
        '& .MuiDataGrid-cell:not(:has(> *))': {
          color: `${theme.palette.red.light}!important`,
          backgroundColor: `theme.palette.red.dark!important`,
        },
        '[data-id^="auto-generated-row-"].MuiDataGrid-row.Mui-selected': {
          backgroundColor: `${theme.palette.red.light}!important`,
        },
        '[data-id^="auto-generated-row-"].MuiDataGrid-row:hover': {
          backgroundColor: `${theme.palette.red.light}`,
        },
      },
    },
  ],
};
